module.exports = __webpack_public_path__ + "static/media/velour9A.be1c69ed.jpg";